import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import WakuwakuStudioLog from "../pages/wakuwaku-studio-log/page";
import WorksSecret from "../pages/works/page";
import MinohSoundscapes from "../pages/minoh-soundscapes/page";
import KatsuojiWorks from "../pages/katsuoji-works/page";
import Privacy from "../pages/privacy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/works-secret",
    element: <WorksSecret />,
  },
  {
    path: "/wakuwaku-studio-log",
    element: <WakuwakuStudioLog />,
  },
  {
    path: "/minoh-soundscapes",
    element: <MinohSoundscapes />,
  },
  {
    path: "/katsuoji-works",
    element: <KatsuojiWorks />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;